import styled from 'styled-components';
import { respondTo } from '../../../styles/shared/breakpoints';

export const MultiBrandStyledLayout = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1440px;
  box-shadow: 0 0 80px 0 rgba(46, 55, 144, 0.08);
  margin: 0 auto;
  min-height: 100vh;
  border: 1px solid #C0C3DE;
 overflow-x: clip;
//  div {
//   scroll-margin-top: 60px;
// }
`;

export const MultiBrandPageMain = styled.main`
  /* max-height: 100vh;
  overflow-y: scroll; */

  ${respondTo.sm`
    overflow: unset;
    max-height: unset;
  `}
`;